// extracted by mini-css-extract-plugin
module.exports = {"cxugd4c":"cxugd4c"};